export function sum(a: number, b: number) {
  return a + b;
}

export const removeTrailingZeros = (numberStr: string) => {
  if (numberStr.includes('.')) {
    const [integerPart, decimalPart] = numberStr.split('.');

    // 去除小数部分的末尾零
    let trimmedDecimal = decimalPart;
    if (decimalPart) {
      let end = decimalPart.length;
      while (end > 0 && decimalPart[end - 1] === '0') end--;
      trimmedDecimal = decimalPart.substring(0, end);
    }

    // 重组结果
    return trimmedDecimal === ''
      ? integerPart // 小数部分全被移除时省略小数点
      : `${integerPart}.${trimmedDecimal}`;
  }
  return numberStr; // 无小数点直接返回
};
